import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** crescent moon. Decorative line icon; always pair with a visible text label. */
export function MoonIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M20.2 14.2A8.3 8.3 0 0 1 9.8 3.8a8.3 8.3 0 1 0 10.4 10.4z" />
    </IconSvg>
  )
}
